import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PerformanceObserverEntryTypes } from '../../const';
export var BufferWithMaxLength = /*#__PURE__*/function () {
  function BufferWithMaxLength() {
    var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    _classCallCheck(this, BufferWithMaxLength);
    _defineProperty(this, "buffer", []);
    _defineProperty(this, "full", false);
    this.maxLength = maxLength;
  }
  return _createClass(BufferWithMaxLength, [{
    key: "push",
    value: function push(item) {
      if (this.full || this.maxLength === this.buffer.length) {
        this.full = true;
        this.buffer.shift();
      }
      this.buffer.push(item);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.buffer;
    }
  }]);
}();
export var EntriesBuffer = _defineProperty(_defineProperty({}, PerformanceObserverEntryTypes.LongTask, new BufferWithMaxLength()), PerformanceObserverEntryTypes.LayoutShift, new BufferWithMaxLength());